import React, { useCallback, useEffect, useState } from "react";
import PanelWrapper from "./PanelWrapper";
import { useDispatch, useSelector } from "react-redux";
import {
  connectStripeAccountAction,
  getStripeAccountStatusAction,
  getUserBalanceAction,
  payoutHistoryAction,
} from "../../Services/Store/Actions/AuthActions";
import { Button, Card, Col, Table } from "react-bootstrap";
import { webSiteUrl } from "../../utils/env";

import CustomButton from "../../Components/Button";
import RequestPayoutModal from "../../Components/Modals/RequestPayoutModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faChevronRight,
  faCircleXmark,
  faClock,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { PaginationType } from "../../Constants/Interfaces";
import moment from "moment";
import RightSlidingPanel from "../Admin/Components/RightSlidingPanel";
import PayoutDetails from "./Components/PayoutDetails";
import ActionMenu from "../../Components/ActionMenu";
import Pagination from "../../Components/Pagination";

interface AccountStatus {
  hasAccount: boolean;
  isComplete: boolean;
  detailsSubmitted: boolean;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
}

interface BalanceDetails {
  available: number;
  pending: number;
  instant_available?: number;
  totalEarnings?: number;
  paidOut?: number;
  inConnectedAccount?: number;
}

const StripePayouts = () => {
  const dispatch = useDispatch();
  const { stripeAccount, stripeBalance, payoutsHistory } = useSelector(
    (state: any) => state.auth
  );

  const [connectLoading, setConnectLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);

  const [requestPayout, setRequestPayout] = useState(false);
  const [listType, setListType] = useState("All");

  const [pagination, setPagination] = useState<PaginationType | null>();

  const [rightSidePanel, setRightSidePanel] = useState({
    show: false,
    item: null,
  });
  const [payoutsList, setPayoutsList] = useState([]);
  const [balance, setBalance] = useState<BalanceDetails | null>();
  const [accountStatus, setAccountStatus] = useState<AccountStatus | null>();

  const connectAccount = useCallback(() => {
    if (!connectLoading) {
      setConnectLoading(true);

      connectStripeAccountAction(
        { url: `${webSiteUrl}/user/payouts` },
        dispatch
      )
        .then((res) => {
          console.log("RES :", res);

          if (res.type === "success" && res.data && res.data.url) {
            window.location.href = res.data.url;
          }
        })
        .catch((err) => {
          console.log("ERR :", err);
        })
        .finally(() => {
          setConnectLoading(false);
        });
    }
  }, []);

  const getAccountStatus = useCallback(() => {
    if (!statusLoading) {
      setStatusLoading(true);

      getStripeAccountStatusAction(dispatch)
        .then((res) => {
          console.log("Status RES:", res);
        })
        .catch((err) => {
          console.log("ERR :", err);
        })
        .finally(() => setStatusLoading(true));
    }
  }, [statusLoading]);

  const getAccountBalance = useCallback(() => {
    if (!balanceLoading) {
      setBalanceLoading(true);

      getUserBalanceAction(dispatch)
        .then((res) => {
          console.log("Status RES:", res);
        })
        .catch((err) => {
          console.log("ERR :", err);
        })
        .finally(() => setBalanceLoading(true));
    }
  }, []);

  const getPayoutHistory = useCallback(
    (page = 1) => {
      if (!historyLoading) {
        setHistoryLoading(true);

        const params = {
          page,
          limit: 20,
          // status: "", // pending | transfer_processing | transfer_completed
        };

        if (listType !== "All") {
          params.status = listType;
        }

        payoutHistoryAction(params, dispatch)
          .then((res) => {
            setPagination(res.data.pagination);

            console.log("Status RES:", res);
          })
          .catch((err) => {
            console.log("ERR :", err);
          })
          .finally(() => setHistoryLoading(false));
      }
    },
    [listType]
  );

  useEffect(() => {
    setBalance({ ...balance, ...stripeBalance });
  }, [stripeBalance]);

  useEffect(() => {
    setPayoutsList(payoutsHistory);
  }, [payoutsHistory]);

  useEffect(() => {
    setAccountStatus({
      ...accountStatus,
      ...stripeAccount,
    });
  }, [stripeAccount]);

  useEffect(() => {
    console.log("listType :", listType);

    getPayoutHistory();
  }, [listType]);

  useEffect(() => {
    getAccountStatus();
    getAccountBalance();
    getPayoutHistory();
  }, []);

  console.log("payoutsList :", payoutsList);
  // console.log("stripeAccount Balance :", balance);

  return (
    <PanelWrapper>
      <div className="container">
        <div className="page-header">
          <h2>Payouts</h2>

          <div className="action-btns-wrapper">
            {!accountStatus?.hasAccount && (
              <CustomButton
                isLoading={connectLoading}
                title="Connect Account"
                onClick={() => connectAccount()}
              />
            )}

            {accountStatus?.hasAccount && !accountStatus?.isComplete && (
              <CustomButton
                isLoading={connectLoading}
                title="Complete Setup"
                onClick={() => connectAccount()}
              />
            )}

            {accountStatus?.hasAccount && accountStatus?.isComplete && (
              <Button onClick={() => setRequestPayout(true)}>
                Request Withdrawal
              </Button>
            )}
          </div>
        </div>

        <div className="payout-cards-wrapper">
          <div className="row">
            <Col md={4}>
              <Card>
                {/* <Card.Header></Card.Header> */}
                <Card.Body>
                  <h2>${balance?.available}</h2>
                  <p>Available</p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card>
                <Card.Body>
                  <h2>${balance?.pending}</h2>
                  <p>Pending</p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card>
                <Card.Body>
                  <h2>${balance?.totalEarnings}</h2>
                  <p>Total Earnings</p>
                </Card.Body>
              </Card>
            </Col>
          </div>
        </div>

        <div className="page-content-card">
          <div className="content-card-header">
            <h3>List of Payouts</h3>

            <div className="filter-area">
              <div className="form-group custom-select">
                <select
                  className="form-control"
                  onChange={(e) => setListType(e.target.value)}
                  value={listType}
                >
                  {/* // pending
                  pending, processing, completed, failed, cancelled
                  */}
                  <option>All</option>
                  <option value="pending">Pending</option>
                  <option value="processing">Processing</option>
                  <option value="completed">Completed</option>
                  <option value="failed">Failed</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
              {/* 
              <div className="form-group">
                <DatePicker
                  showIcon
                  icon="far fa-calendar"
                  value={
                    filters.endDate
                      ? moment(filters.endDate).format("MM/DD/YYYY")
                      : ""
                  }
                  selected={filters.endDate}
                  className="form-control"
                  placeholderText="End Date"
                  onChange={(date: Date) => onFilterChange("endDate", date)}
                />
              </div>

              <CustomButton title="" onClick={() => getPaymentsList(1)}>
                <FontAwesomeIcon icon={faSearch} />
              </CustomButton> */}
            </div>
          </div>

          <div className="listing-tables">
            <Table responsive>
              <thead>
                <tr>
                  <th>Transaction ID</th>
                  <th>Amount</th>
                  <th>Request Date</th>
                  <th style={{ width: 100 }}>Status</th>
                  <th className="action-col">Action</th>
                </tr>
              </thead>

              <tbody>
                {!historyLoading && payoutsList.length === 0 && (
                  <tr>
                    <td colSpan={5} align="center">
                      No Payouts available
                    </td>
                  </tr>
                )}

                {payoutsList.length > 0 &&
                  payoutsList.map((item, index) => (
                    <tr key={`booking-${item.id}`}>
                      <td>{item?.stripeTransferId || ""}</td>
                      <td>${item?.grossAmount}</td>
                      <td>
                        {item &&
                          item.payoutDate &&
                          moment(item.payoutDate).format("MM/DD/YYYY")}
                      </td>
                      <td className="text-capitalized">
                        {item?.status === "completed" && (
                          <span
                            className="status-icons text-success"
                            title="Success"
                          >
                            <FontAwesomeIcon icon={faCheckCircle} />
                          </span>
                        )}
                        {item?.status === "pending" && (
                          <span
                            className="status-icons text-warning"
                            title="Pending"
                          >
                            <FontAwesomeIcon icon={faClock} />
                          </span>
                        )}
                        {item?.status === "failed" && (
                          <span
                            className="status-icons text-danger"
                            title="Failed"
                          >
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </span>
                        )}
                        {item?.status === "processing" && (
                          <span
                            className="status-icons text-warning"
                            title={item.status}
                          >
                            <FontAwesomeIcon icon={faClock} />
                          </span>
                        )}
                      </td>
                      <td className="action-col">
                        <ActionMenu
                          items={[
                            {
                              label: "Details",
                              icon: faChevronRight,
                              onClick: () =>
                                setRightSidePanel({ show: true, item }),
                            },
                          ]}
                        />
                      </td>
                    </tr>
                  ))}

                {historyLoading && (
                  <tr>
                    <td colSpan={5} align="center">
                      <FontAwesomeIcon icon={faSpinner} spin />
                    </td>
                  </tr>
                )}
              </tbody>

              <tfoot>
                <tr>
                  <td colSpan={5}>
                    <Pagination
                      pagination={pagination}
                      onPageChange={(page) => getPayoutHistory(page)}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </div>

      {requestPayout && (
        <RequestPayoutModal
          show={requestPayout}
          onClose={() => setRequestPayout(false)}
          onSuccess={() => {
            getPayoutHistory();
            getAccountBalance();
          }}
        />
      )}

      {rightSidePanel.show && (
        <RightSlidingPanel
          title="Payout Details"
          show={rightSidePanel.show}
          onClosePanel={() => setRightSidePanel({ show: false, item: null })}
        >
          <PayoutDetails itemId={rightSidePanel?.item?.id} />
        </RightSlidingPanel>
      )}
    </PanelWrapper>
  );
};

export default StripePayouts;
